import { useEffect, useCallback } from 'react';
import { Helmet } from 'react-helmet';
import { useMetaMask } from 'metamask-react';

import styles from '../styles/pages/Home.module.scss';

const MY_ADDRESS = '0x54486ed1db65Bc55e0cc049eBd9ba03eaBf08fDC';

const METAMASK_STATUS = {
  INITIALIZING: 'initializing',
  UNAVAILABLE: 'unavailable',
  NOT_CONNECTED: 'notConnected',
  CONNECTING: 'connecting',
  CONNECTED: 'connected',
};

const Home = () => {
  const { status, connect, account } = useMetaMask();

  const getAngles = (clientX, clientY) => {
    const menu = document.querySelector(`.${styles.home}`);
    const menuRect = menu.getBoundingClientRect();
    const { x, y, width, height } = menuRect;
    const dx = clientX - (x + 0.5 * width);
    const dy = clientY - (y + 0.5 * height);
    return { dx, dy };
  };

  const setAngles = useCallback(({ clientX, clientY }) => {
    const { dx, dy } = getAngles(clientX, clientY);
    const menu = document.querySelector(`.${styles.home}`);
    menu?.attributeStyleMap?.set('--x', `${dy / 20}deg`);
    menu?.attributeStyleMap?.set('--y', `${dx / 20}deg`);
  }, []);

  useEffect(() => {
    window.addEventListener('mousemove', setAngles);

    return () => window.removeEventListener('mousemove', setAngles);
  }, [setAngles]);

  useEffect(() => {
    if (status === METAMASK_STATUS.NOT_CONNECTED) {
      connect();
    }
  }, [status, connect]);

  return (
    <div className={styles.home}>
      <Helmet>
        <script src="https://cdn.rawgit.com/pierregoutheraud/metamask-transaction-button/6ebebf41/build/static/js/mtb.js" />
      </Helmet>
      <div className={styles.home__spotify}>
        <iframe
          title="spotify"
          src="https://open.spotify.com/embed/album/4L7FpJdUHRQkjAkfioeDUZ"
          width="100%"
          height="80"
          frameBorder="0"
          allowtransparency="true"
        />
      </div>
      <div className={styles.home__login_status}>
        {status === METAMASK_STATUS.INITIALIZING && (
          <div>Synchronisation with MetaMask ongoing...</div>
        )}
        {status === METAMASK_STATUS.UNAVAILABLE && (
          <div>MetaMask not available</div>
        )}
        {status === METAMASK_STATUS.CONNECTING && <div>Connecting...</div>}
        {status === METAMASK_STATUS.CONNECTED && (
          <>
            <div>Connected:</div>
            <div>{account}</div>
          </>
        )}
      </div>
      <div className={styles.home__menu_wrapper}>
        <ul className={styles.home__menu}>
          <li>
            <button
              type="button"
              onClick={() => window.open('https://github.com/metalemon')}
            >
              @MetaLemon
            </button>
          </li>
          <li>
            <button
              type="button"
              onClick={() => window.open('/demo/lemon-legends')}
            >
              Lemon Legends
            </button>
          </li>
        </ul>
      </div>
      {status !== METAMASK_STATUS.UNAVAILABLE && (
        <div className={styles.home__metamask_donate}>
          <div
            className="metamask-button"
            address={MY_ADDRESS}
            amount="0.001"
          />
        </div>
      )}
      <div className={styles.home__footer}>© 2021 MetaLemon</div>
    </div>
  );
};

export default Home;
